import _ from 'underscore'
import rpcCall from '../../util/rpc/rpcCalls'
import CustomerProjectSelection from "../../CustomerProjectSelection"
import {isOnlyCompletedType, isOnlyDirectlySelectedStatuses, isOnlyOpenType} from '../../workflowStatus/components/statusFilter/utils'
import ClassicBridge from '../../next/ClassicBridge'
import {CustomFieldsPrefix} from '../../customFields/constants'
import {arrayToSet} from '../../atUtils'

const ID_LIMIT_IN_QUERY = 500

export function makeLoadTasksRequest({
    intersectedCPSelection,
    taskStatusFilter,
    taskNameFilter,
    showOnlyManageableTasks,
    taskSorting,
    offset = 0,
    limit = null
}) {
    const loadByNextSorting = taskSorting.by.includes(CustomFieldsPrefix)
    const fillCommonNextDataParams = (params) => {
        fillNextParamsWithCPSelection(params, intersectedCPSelection)
        fillNextParamsWithTaskStatusFilter(params, taskStatusFilter)
        fillNextParamsWithTaskNameFilter(params, taskNameFilter)
        fillNextParamsWithOnlyManageableTasks(params, showOnlyManageableTasks)
    }
    if (loadByNextSorting) {
        const params = {
            sortField: taskSorting.by,
            ascSort: taskSorting.asc,
            offset,
            limit,
        }
        fillCommonNextDataParams(params)

        return ClassicBridge.getTasksForTaskList(params).then(nextData => {
            const taskIds = _.pluck(nextData.items, "classicId")
            const classicDataPromise = rpcCall(
                "TaskManagementService.getTasks",
                [taskIds, intersectedCPSelection],
                () => true
            )
            return Promise.all([classicDataPromise, nextData, taskIds])
        }).then(([rpcData, nextData, taskIds]) => {
            // sort tasks by next data
            rpcData.tasks = _.sortBy(rpcData.tasks, (task) => {
                return taskIds.indexOf(task.id)
            })
            return mergeRpcAndNextData(rpcData, nextData)
        })
    } else {
        return rpcCall(
            "TaskManagementService.getTasks",
            [intersectedCPSelection, taskStatusFilter, taskNameFilter, showOnlyManageableTasks, taskSorting.by, taskSorting.asc, offset, limit],
            () => true
        ).then(rpcData => {
            const taskIds = _.pluck(rpcData.tasks, "id")
            let nextDataPromise
            if (taskIds.length > ID_LIMIT_IN_QUERY) {
                const params = {}
                fillCommonNextDataParams(params)
                nextDataPromise = ClassicBridge.getTasksForTaskList(params)
                                               .then(data => {
                                                   const taskIdsSet = arrayToSet(taskIds)
                                                   data.items = data.items.filter(target => !!taskIdsSet[target.classicId])
                                                   return data
                                               })
            } else {
                nextDataPromise = ClassicBridge.getTasksForTaskList({taskIds: taskIds})
            }
            return Promise.all([rpcData, nextDataPromise])
        }).then(([rpcData, nextData]) => {
            return mergeRpcAndNextData(rpcData, nextData)
        })
    }
}

function mergeRpcAndNextData(rpcData, nextData) {
    const nextValuesDataMap = {}
    nextData.items.forEach(nextTask => {
        nextValuesDataMap[nextTask.classicId] = {
            nextId: nextTask.id,
            ...(_.omit(nextTask, (values, key) => {
                return !key.includes(CustomFieldsPrefix)
            })),
        }
    })

    rpcData.tasks = rpcData.tasks.map((task) => {
        return {
            ...task,
            ...(nextValuesDataMap[task.id] || {})
        }
    })

    return rpcData
}

function fillNextParamsWithCPSelection(params, cpSelection) {
    if (cpSelection.qualifier === CustomerProjectSelection.Qualifier.SELECTED) {
        if (cpSelection.customers.length !== 0)
            params.customerIds = cpSelection.customers
        if (cpSelection.projects.length !== 0)
            params.projectIds = cpSelection.projects
    }
}

function fillNextParamsWithTaskStatusFilter(params, taskStatusFilter) {
    if (isOnlyOpenType(taskStatusFilter))
        params.active = true
    if (isOnlyCompletedType(taskStatusFilter))
        params.active = false

    if (isOnlyDirectlySelectedStatuses(taskStatusFilter))
        params.workflowStatusIds = taskStatusFilter.statusIds
}

function fillNextParamsWithTaskNameFilter(params, taskNameFilter) {
    if (taskNameFilter)
        params.titleSearch = taskNameFilter
}

function fillNextParamsWithOnlyManageableTasks(params, onlyManageableTasks) {
    if (onlyManageableTasks)
        params.onlyEditable = onlyManageableTasks
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/connector.js